// import { faPlus } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Button from "components/base/Button";
// import DealDetailsCallTable from "components/tables/DealDetailsCallTable";
// import { Col, Form, Row } from "react-bootstrap";

// const DealDetailsCall = ({ phoneNotes }: any) => {
//   return (
//     <>
//       <Row className="align-items-center gx-4 gy-3 flex-wrap mb-3">
//         <Col sm="auto" className="flex-1">
//           <h2 className="mb-0">Call</h2>
//         </Col>
//         <Col sm="auto">
//           <div className="d-sm-flex align-items-center gap-4">
//             <div className="d-flex gap-3 gap-sm-4">
//               <Form.Check
//                 type="radio"
//                 label="All Call"
//                 name="callType"
//                 id="all-call"
//                 defaultChecked
//                 className="mb-sm-0"
//               />
//               <Form.Check
//                 type="radio"
//                 label="Incoming Call"
//                 name="callType"
//                 id="incoming-call"
//                 className="mb-sm-0"
//               />
//               <Form.Check
//                 type="radio"
//                 label="OutgoingCall"
//                 name="callType"
//                 id="outgoing-call"
//                 className="mb-sm-0"
//               />
//             </div>
//             <Button
//               variant="primary"
//               startIcon={<FontAwesomeIcon icon={faPlus} className="me-2" />}
//             >
//               Add Call
//             </Button>
//           </div>
//         </Col>
//       </Row>
//       <DealDetailsCallTable />
//     </>
//   );
// };

// export default DealDetailsCall;

import { Button, Form } from "react-bootstrap";
import { Note } from "data/crm/dealDetailsData";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import { useForm, SubmitHandler } from "react-hook-form";
import axiosInstance from "helpers/api";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { dateFormatter } from "helpers/utils";
import { useEffect, useState } from "react";

type Inputs = {
  note: string;
};

const DealDetailsCall = ({ phoneNotes }: any) => {
  const [noteItems, setNoteItems] = useState<any>([]);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();
  let { id } = useParams();

  useEffect(() => {
    setNoteItems(phoneNotes);
  }, [phoneNotes]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const response = await axiosInstance.post(`/deals/${id}/call-notes`, {
        note: data.note,
      });
      toast.success(response.data.message);
      reset();
      setNoteItems((prevNoteItems: any) => [
        ...prevNoteItems,
        {
          call_note: data.note,
          created_on: Date.now(),
        },
      ]);
    } catch (error: any) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <>
      <h2 className="mb-4">Call Notes</h2>

      <Form onSubmit={handleSubmit(onSubmit)} className="mb-5">
        <Form.Control
          as="textarea"
          rows={6}
          className="mb-3"
          {...register("note", { required: true, maxLength: 100 })}
        />
        {errors.note?.type === "required" && (
          <p role="alert" className="text-danger fs-9 pt-1 mb-0">
            Description Required
          </p>
        )}
        <Button variant="primary" type="submit" className="my-0">
          Create Note
        </Button>
      </Form>

      {noteItems?.map((item: any, index: any) => (
        <div
          key={item?.id}
          className={classNames("border-2 border-dashed border-translucent", {
            "mb-4 pb-4 border-bottom": index !== noteItems?.length - 1,
          })}
        >
          <p className="mb-1 text-body-highlight">{item?.call_note}</p>
          <div className="d-sm-flex">
            <div className="fs-9 text-body-tertiary text-opacity-85">
              <FontAwesomeIcon icon={faClock} className="me-2" />
              <span className="fw-semibold me-1">
                {dateFormatter(item?.created_on)}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default DealDetailsCall;
